import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

/** Cargo que o dono/adm escolheu para ver a tela (menu da conta). `null` = o próprio. */
export type VerComo = 'lojista' | 'comprador' | null;

type VerComoStore = {
  verComo: VerComo;
  setVerComo: (verComo: VerComo) => void;
};

/**
 * "Ver como lojista/comprador": troca temporária de cargo para o dono e o adm conferirem o acesso
 * de cada cargo pelo site inteiro (pedido do Arthur, 07/10/2026). Na tela, quem lê é o `usePerfil`;
 * no back, o axios manda `X-Ver-Como` e o guard trata a requisição como aquele cargo.
 *
 * Fica no sessionStorage: vale até voltar pelo menu ou fechar a aba, e recarregar a página
 * não desfaz.
 */
export const useVerComo = create<VerComoStore>()(
  persist(
    set => ({
      verComo: null,
      setVerComo: verComo => set({ verComo }),
    }),
    { name: 'rico:ver-como', storage: createJSONStorage(() => sessionStorage) },
  ),
);
